import { render, staticRenderFns } from "./MenuRectangleTerminalFilled.vue?vue&type=template&id=21a9c48a"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports